$(document).ready(function () {

  $('#accordion').accordion({
    heightStyle: 'content',
    collapsible: true,
    active: false
  });

  $('#terms-accordion').accordion({
    heightStyle: 'content',
    collapsible: true,
    active: false
  });

  $('#duties-accordion').accordion({
    heightStyle: 'content',
    collapsible: true,
    active: false
  });

  $('#faq-accordion').accordion({
    heightStyle: 'content',
    collapsible: true,
    active: false
  });

  updateAccordion();
});

window.addEventListener('hashchange', updateAccordion);

function updateAccordion() {
  // Use page anchor to open specific accordion leaf.
  var anchorValue = (window.location.hash.length > 1) ? window.location.hash : null;
  if (anchorValue) {
    var el = $(anchorValue);
    var index = $('#faq-accordion .top-heading').index(el);
    $('#faq-accordion').accordion('option', 'active', index);
    setTimeout(function() {window.scrollBy(0, -150);}, 500);
  }
}